import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/svgs/dots_gray.svg'


const _hoisted_1 = { class: "flex flex-col w-3/5" }
const _hoisted_2 = { class: "flex flex-col text-sm text-gray-500 mt-2" }
const _hoisted_3 = { class: "flex flex-row items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "PTO days", -1)
const _hoisted_5 = {
  key: 0,
  class: "bg-background p-2 rounded mr-2"
}
const _hoisted_6 = { class: "bg-background p-2 rounded" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_9 = { class: "flex flex-col flex-grow justify-between" }
const _hoisted_10 = { class: "flex flex-row items-start justify-end" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "bg-blue-100 runded p-2 text-sm rounded mr-2"
}
const _hoisted_13 = { class: "text-blue-500" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", { class: "px-2 pt-3" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row justify-end text-center"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 text-sm font-medium" }, "Dismissed", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "flex flex-row justify-end text-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row border-2 border-yellow-500 rounded-full px-4 py-2 text-sm w-fit mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 font-medium" }, "Dismissal in progress")
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  class: "flex flex-row justify-end text-center"
}
const _hoisted_22 = {
  key: 0,
  class: "flex flex-row bg-primary rounded-full px-4 py-2 text-sm w-fit mt-2"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-white font-medium" }, "Start hiring process", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "flex flex-row border-2 border-primary rounded-full px-4 py-2 text-sm w-fit mt-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-medium" }, "Finish hiring process", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 2,
  class: "flex flex-row text-sm w-fit mt-2"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 font-medium" }, "Hired", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 3,
  class: "flex flex-row items-center justify-end text-sm text-gray-500 mt-2"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Entry date", -1)
const _hoisted_33 = {
  key: 0,
  class: "bg-background p-2 rounded"
}
const _hoisted_34 = {
  key: 4,
  class: "flex flex-row items-center justify-end text-sm text-gray-500 mt-2"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Dismissal date", -1)
const _hoisted_36 = {
  key: 0,
  class: "bg-background p-2 rounded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/talent/${_ctx.talent.id}/timeline`))),
      class: _normalizeClass(["flex flex-row rounded-2xl p-8", {
        'bg-white shadow': _ctx.talent.status !== 'dismissed',
        'bg-gray-200': _ctx.talent.status === 'dismissed',
      }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_UserCard, {
          firstName: _ctx.talent.first_name,
          lastName: _ctx.talent.last_name,
          position: _ctx.talent.job_title
        }, null, 8, ["firstName", "lastName", "position"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.talent.pto)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.talent.pto.balance) + "/" + _toDisplayString(_ctx.talent.pto.max_balance), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.talent.Empleado_ID), 1)
          ]),
          (_ctx.talent.company)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.talent.company.visible_name), 1))
            : _createCommentVNode("", true),
          (_ctx.talent.salary)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " $" + _toDisplayString((_ctx.talent.salary.biweekly / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })) + " (MXN) ", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.talent.tasks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (
                _ctx.talent.tasks.completed > 0 &&
                _ctx.talent.tasks.completed !== _ctx.talent.tasks.total
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, " Onboarding " + _toDisplayString(_ctx.talent.tasks.completed) + " of " + _toDisplayString(_ctx.talent.tasks.total), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_14
        ]),
        (_ctx.talent.status === 'dismissed')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : (_ctx.talent.status === 'dismissal_in_progress')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (_ctx.talent.onboarding_status === 'not_started')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                  : _createCommentVNode("", true),
                (
              _ctx.talent.onboarding_status === 'started' ||
              _ctx.talent.onboarding_status === 'pending_hiring'
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                  : _createCommentVNode("", true),
                (_ctx.talent.onboarding_status === 'hired')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                  : _createCommentVNode("", true)
              ])),
        (_ctx.talent.status !== 'dismissed')
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _hoisted_32,
              (_ctx.talent.entry_day)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createVNode(_component_DateFormatter, {
                      date: _ctx.talent.entry_day
                    }, null, 8, ["date"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              (_ctx.talent.baja_fecha)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createVNode(_component_DateFormatter, {
                      date: _ctx.talent.baja_fecha
                    }, null, 8, ["date"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ], 2)
  ]))
}